// frontend/src/components/FastReact/Restock.jsx
//
// Reuses the exact same Plano Teares view/table (same as Recolha Fios does),
// just defaulting the status filter to COMPLETED. All other filters remain
// available and behave identically — initialFilters only overrides the
// default value, the person can still change it from the UI.
//
// hideUntilFilter: the list starts empty/hidden (filters stay visible and
// usable) and only loads + shows matching records once the person actually
// changes a filter — Restock's working set (every COMPLETED order) is too
// broad to dump on screen by default.

import React from 'react';
import PlanoTeares from './PlanoTeares';

const Restock = () => (
  <PlanoTeares initialFilters={{ status: 'COMPLETED' }} hideAdvanceUndo hideUntilFilter />
);

export default Restock;